module.exports = __webpack_public_path__ + "img/freebg.6eddc6a5.jpg";